import styled from 'styled-components';
import { H3 } from 'features/shared/ui/Heading';

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  width: 736px;
  max-width: calc(100vw - 96px);
  max-height: 600px;
  box-sizing: border-box;
  overflow: hidden;
`;

export const ModalTitle = styled(H3)`
  text-align: center;
`;

export const ModalTextWrap = styled.div`
  width: 100%;
  flex: 1;
  min-height: 0;
  overflow: auto;
  background-color: #f4f5f6;
  padding: 24px;
  border-radius: 16px;
  box-sizing: border-box;
`;

export const ModalText = styled.div`
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  color: var(--font-color);
  word-break: break-word;
  white-space: pre-wrap;
`;

export const CopyActions = styled.div<{ $copied?: boolean }>`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  width: 100%;

  button {
    gap: 8px;
  }

  svg {
    display: block;
    flex-shrink: 0;
    width: ${({ $copied }) => ($copied ? '15px' : '24px')};
    height: ${({ $copied }) => ($copied ? '15px' : '24px')};

    path {
      fill: currentColor;
    }
  }
`;
